import { PANELS, panelLockNames } from 'constants/event_type_editor_panels'

import { AssignPanel } from './components/event_details/assign_panel'
import { AvailabilityPanel } from './components/event_details/availability_panel'
import { DurationPanel } from './components/event_details/duration_panel'
import { GroupEventPanel } from './components/event_details/group_event_panel'
import { HostsPanel } from './components/event_details/hosts_panel'
import { LocationPanel } from './components/event_details/location_panel'
import { BookingPageOptionsPanel } from './more_options/booking_page_options_panel'
import { ConfirmationPagePanel } from './more_options/confirmation_page_panel'
import { DescriptionPanel } from './more_options/description_panel'
import { FreeBusyRulesPanel } from './more_options/free_busy_rules_panel'
import { InviteeFormPanel } from './more_options/invitee_form_panel'
import { LimitsAndBuffersPanel } from './more_options/limits_and_buffers_panel'
import { NotificationsPanel } from './more_options/notifications_panel'
import { PaymentPanel } from './more_options/payment_panel'

export { PANELS, panelLockNames }

export const panelComponentsByKey = {
  [PANELS.duration]: DurationPanel,
  [PANELS.location]: LocationPanel,
  [PANELS.availability]: AvailabilityPanel,
  [PANELS.groupEvent]: GroupEventPanel,
  [PANELS.hosts]: HostsPanel,
  [PANELS.assign]: AssignPanel,
  [PANELS.description]: DescriptionPanel,
  [PANELS.limitsAndBuffers]: LimitsAndBuffersPanel,
  [PANELS.freeBusyRules]: FreeBusyRulesPanel,
  [PANELS.bookingPageOptions]: BookingPageOptionsPanel,
  [PANELS.inviteeForm]: InviteeFormPanel,
  [PANELS.payment]: PaymentPanel,
  [PANELS.notifications]: NotificationsPanel,
  [PANELS.confirmationPage]: ConfirmationPagePanel
}
